export default {
  path: '/style2',
  name: 'Index',
  component: () => import(`@/views/style2/Index.vue`),
  children: [
    {
      path: 'home',
      name: 'Home',
      component: () => import(`@/views/style2/Home.vue`),
    },
    {
      path: 'info',
      name: 'Info',
      component: () => import(`@/views/style2/Info.vue`),
    },
    {
      path: 'project',
      name: 'Project',
      component: () => import(`@/views/style2/Project.vue`),
    },
    {
      path: 'news',
      name: 'News',
      component: () => import(`@/views/style2/News.vue`),
    },
    {
      path: 'contact',
      name: 'Contact',
      component: () => import(`@/views/style2/Contact.vue`),
    },
    {
      path: 'detail',
      name: 'NewsDetail',
      component: () => import(`@/views/style2/NewsDetail.vue`),
    },
    {
      path: 'expert',
      name: 'EXPERT',
      component: () => import(`@/views/style2/Expert.vue`),
    },
  ]
}
